/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
 

export enum boardTypeEnum {
  NONE = 'None',
  SELF_CATERING = 'SelfCatering',
  BREAKFAST = 'Breakfast',
  HALF_BOARD = 'HalfBoard',
  HALF_BOARD_PLUS = 'HalfBoardPlus',
  FULL_BOARD = 'FullBoard',
  FULL_BOARD_PLUS = 'FullBoardPlus',
  ALL_INCLUSIVE = 'AllInclusive',
  ALL_INCLUSIVE_PLUS = 'AllInclusivePlus',
}
